var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login',{attrs:{"action":"/admin/oauth"},on:{"loginSuccess":_vm.handleLoginSuccess},scopedSlots:_vm._u([{key:"resetPassword",fn:function(){return [_c('router-link',{attrs:{"to":{ name: 'admin-forgot-password'}}},[_vm._v("Forgot Password?")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }